import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import StagePayet from "@/pages/StagePayet";
import StagePro from "@/pages/StagePro";
import MatchsAmicaux from "@/pages/MatchsAmicaux";
import Boutique from "@/pages/Boutique";
import Equipementier from "@/pages/Equipementier";
import Sponsors from "@/pages/Sponsors";
import QuiSommesNous from "@/pages/QuiSommesNous";
import Contact from "@/pages/Contact";
import StageDetail from "@/pages/StageDetail";
import Inscription from "@/pages/Inscription";
import PaiementSucces from "@/pages/PaiementSucces";
import PaiementAnnule from "@/pages/PaiementAnnule";
import { MentionsLegales, PolitiqueConfidentialite } from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminStages from "@/pages/admin/AdminStages";
import AdminStageForm from "@/pages/admin/AdminStageForm";
import AdminRegistrations from "@/pages/admin/AdminRegistrations";
import AdminRegistrationDetail from "@/pages/admin/AdminRegistrationDetail";
import AdminGaleries from "@/pages/admin/AdminGaleries";
import AdminSponsors from "@/pages/admin/AdminSponsors";
import AdminClubs from "@/pages/admin/AdminClubs";
import AdminContenus from "@/pages/admin/AdminContenus";
import AdminCodesPromo from "@/pages/admin/AdminCodesPromo";
import AdminDemandes from "@/pages/admin/AdminDemandes";
import AdminPlaceholder from "@/pages/admin/AdminPlaceholder";

const TITLES = {
  "/": "3M Match Pro — Stages de football & matchs amicaux",
  "/qui-sommes-nous": "Qui sommes-nous — 3M Match Pro",
  "/stage-payet": "Stage Payet — 3M Match Pro",
  "/stage-pro": "Stage Pro / Semi-Pro — 3M Match Pro",
  "/matchs-amicaux": "Matchs amicaux — 3M Match Pro",
  "/boutique": "Boutique — 3M Match Pro",
  "/equipementier": "Équipementier sportif — 3M Match Pro",
  "/sponsors": "Nos sponsors & partenaires — 3M Match Pro",
  "/contact": "Contact — 3M Match Pro",
  "/mentions-legales": "Mentions légales — 3M Match Pro",
  "/politique-confidentialite": "Politique de confidentialité — 3M Match Pro",
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = TITLES[pathname] || (pathname.startsWith("/admin") ? "Espace Staff — 3M Match Pro" : "3M Match Pro");
  }, [pathname]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
          <Route path="/stage-payet" element={<StagePayet />} />
          <Route path="/stage-payet/:slug" element={<StageDetail />} />
          <Route path="/stage-pro" element={<StagePro />} />
          <Route path="/stage-pro/:slug" element={<StageDetail />} />
          <Route path="/inscription/:slug" element={<Inscription />} />
          <Route path="/paiement/succes" element={<PaiementSucces />} />
          <Route path="/paiement/annule" element={<PaiementAnnule />} />
          <Route path="/matchs-amicaux" element={<MatchsAmicaux />} />
          <Route path="/boutique" element={<Boutique />} />
          <Route path="/equipementier" element={<Equipementier />} />
          <Route path="/sponsors" element={<Sponsors />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="stages/payet" element={<AdminStages type="stage_payet" title="Stages Payet" />} />
            <Route path="stages/pro" element={<AdminStages type="stage_pro_semi_pro" title="Stages Pro / Semi-Pro" />} />
            <Route path="stages/nouveau" element={<AdminStageForm />} />
            <Route path="stages/:id/modifier" element={<AdminStageForm />} />
            <Route path="inscriptions" element={<AdminRegistrations />} />
            <Route path="inscriptions/:id" element={<AdminRegistrationDetail />} />
            <Route path="galeries" element={<AdminGaleries />} />
            <Route path="sponsors" element={<AdminSponsors />} />
            <Route path="clubs" element={<AdminClubs />} />
            <Route path="contenus" element={<AdminContenus />} />
            <Route path="codes-promo" element={<AdminCodesPromo />} />
            <Route path="demandes" element={<AdminDemandes />} />
            <Route path="parametres" element={<AdminPlaceholder title="Paramètres" />} />
          </Route>
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div aria-hidden="true" className="noise-overlay pointer-events-none fixed inset-0 z-[5] opacity-[0.045]" />
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: { background: "#121212", border: "1px solid #2a2a2a", color: "#fff" },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
